import urlPrefixes from '../../constants/urlPrefixes';

type TAttributesByKeyParam = {
  attributeKey: string;
  attributeValueKey: string;
};

const createSavedSearchAttrs = (attributesByKey?: TAttributesByKeyParam[]): object => {
  const savedSearchAttrs = { [urlPrefixes.asSavedSearch]: 'true' };
  const offeredSince = attributesByKey && attributesByKey.find((attr) => attr.attributeKey === 'offeredSince');
  if (offeredSince) {
    savedSearchAttrs[urlPrefixes.offeredSince] = offeredSince.attributeValueKey;
  }
  return savedSearchAttrs;
};

export default createSavedSearchAttrs;
